export default __webpack_public_path__ + "static/media/petalwipehd_pr1.24b1f1c0.webm";